import { useState } from 'react'
import PropTypes from 'prop-types'
import { Affix } from 'react-overlays'
import { useScrollDirection } from 'lib/hooks'
import classNames from 'classnames'
import css from './reappearing-header.scss'

const ReappearingHeader = ({
  children,
  placeholderColor,
  placeholderHeight,
  microUtilityBarEnabled,
}) => {
  const scrollDirection = useScrollDirection()
  const [usePlaceholder, setUsePlaceholder] = useState(false)
  const affixClass = classNames(css.affix, {
    [css.downScroll]: scrollDirection === 'down' && usePlaceholder,
  })

  const offsetTop =
    scrollDirection === 'down'
      ? placeholderHeight + placeholderHeight / 2
      : placeholderHeight / 2

  return (
    <>
      {usePlaceholder && (
        <div
          style={{
            display: 'block',
            height: `${placeholderHeight}px`,
            backgroundColor: placeholderColor,
          }}
        />
      )}
      <Affix
        topClassName={classNames(affixClass, css.top)}
        offsetTop={offsetTop}
        affixClassName={classNames(affixClass, {
          [css.microUtilityEnabled]: microUtilityBarEnabled,
        })}
        onAffixed={() => setUsePlaceholder(true)}
        onAffixedTop={() => setUsePlaceholder(false)}
      >
        <div className="fadeIn">{children}</div>
      </Affix>
    </>
  )
}

ReappearingHeader.propTypes = {
  children: PropTypes.node.isRequired,
  placeholderColor: PropTypes.string,
  placeholderHeight: PropTypes.number.isRequired,
}

ReappearingHeader.defaultProps = {
  placeholderColor: 'inherit',
}

export default ReappearingHeader
